import {
  Card as CardCore,
  CardHeader as CardHeaderCore,
} from '@material-ui/core';
import * as lib from '~/dependencies';

export const Card = lib.styled(CardCore)`
  background-color: transparent !important;

  .tour-provider-card-actions-container {
    justify-content: flex-end;
  }

  .actions-container-button {
    text-transform: none;
  }

  .next-button {
    font-weight: bold;
    color: #41a8eb;
`;

export const CardHeader = lib.styled(CardHeaderCore)`
  .tour-provider-card-header-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-radius: 10px;
    background-color: #d6e8cd;
  }


  .MuiTypography-root.MuiCardHeader-title.MuiTypography-body2 {
    font-size: 15px;
    font-weight: bold;
  }

  .step-1 {
      background-color: #d6e8cd;
      svg {
        margin-top: 5px;  
        path {
          fill: #3bbb03;
        }
      }
  }

  .step-2 {
    background-color: #E3F2FD !important;
    svg {
      margin-top: 5px;
      path {
          fill: #41a8eb !important;
      }
    }
  }
`;
